import { useNotData, useData } from "./useNotShowPublicLogic";
import  type { ForceModalData } from "./useNotShowPublicLogic";
import { getWebDomain } from '@/utils/app'
import router from "@/router";
import {uesShowForceModal} from "./useShow"
export const channelForceModal = async() => {

  let isNotShow = [...useNotData().values()].some(fn => fn())
  if (isNotShow) return false

  const channelStore = useChannelStore(); // 渠道信息 
  const tenantStore = useTenantStore()
  const route = router.currentRoute
  const ch = (route.value.query.ch || 0) as number
  await channelStore.reqChannelInfo({
    id: ch,
    tenantId: tenantStore.tenantId || 0,
    domain: getWebDomain(),
  })
  const expireDate = await channelStore.getCompulsoryInstallTime()
  const params: ForceModalData = {
    popupTime: channelStore.promotionInfo?.popupTime,
    installType: channelStore.promotionInfo?.installType,
    guideInstall: channelStore.promotionInfo?.guideInstall,
    popupInterval: Number(channelStore.promotionInfo?.popupInterval) || 0,
    expireDate,
    isNotOpen: false
  }

  isNotShow =[...useData(params).values()].some(fn => fn())
  if (isNotShow) return false


  return uesShowForceModal('compulsoryInstallTime')
}
